<template>
	<v-container>
		<v-col class="px-0">
			<v-row>
				<v-col cols="12" class="text-right">
					<v-btn depressed color="primary" class="rounded-xl" @click="goPrint">
						<v-icon small color="white">mdi-printer</v-icon>
						<span class="pl-2">Print</span>
					</v-btn>
				</v-col>
			</v-row>
			<div id="section-to-print" v-if="!loading">
				<div class="my-3">
					<img width="90" height="auto" src="/img/ic-logo.svg">
					<v-row>
						<v-col cols="12" sm="6">
							<div class="font-size-11 font-weight-500">BalMed Beauty</div>
							<div class="font-size-10">Jl. Tanjung Duren Utara X no 10 Jakarta Barat 11470 Indonesia</div>
							<div class="font-size-10">Telp : 021-56980395, 56949890</div>
							<div class="font-size-10">Admin : +62 838-3298-0305 (Natalia)</div>
							<div class="font-size-10">Email : balmedbeauty.official@gmail.com</div>
						</v-col>
						<v-col cols="12" sm="6" class="text-right my-auto">
							<div class="font-size-13 font-weight-500 text-uppercase">Detail Komisi</div>
							<div class="font-size-11">Komisi Statement</div>
						</v-col>
						<v-col cols="12" class="pt-0">
							<div class="border-bottom border-grey border-2px"></div>
						</v-col>
					</v-row>
				</div>

				<v-row>
					<v-col cols="6" md="6">
						<div>
							<div class="font-size-10">Tanggal</div>
							<div class="font-size-10 cl-secondary font-weight-500">{{ detailHistoryTransfer.bonus_transfer_datetime | tanggal }}</div>
						</div>
					</v-col>
					<v-col cols="6" md="6">
						<div class="text-right">
							<div class="font-size-10">Status</div>
							<div class="font-size-10 cl-secondary font-weight-500 ml-2">
								<v-chip
									:color="detailHistoryTransfer.bonus_transfer_status | toColorStatus"
									outlined
									class="mt-2 px-5 text-uppercase font-weight-bold font-weight-14"
								>{{ detailHistoryTransfer.bonus_transfer_status | toFormatStatus }}</v-chip>
							</div>
						</div>
						<div class="mt-3 text-right" v-if="detailHistoryTransfer.bonus_transfer_status_update_datetime">
							<div class="font-size-10">Tanggal Transfer</div>
							<div class="font-size-10 cl-secondary font-weight-500">{{ detailHistoryTransfer.bonus_transfer_status_update_datetime | tanggal }}</div>
						</div>
					</v-col>
				</v-row>
				
				<v-row>
					<v-col cols="6" md="9">
						<div>
							<div class="font-size-10">Kode Mitra</div>
							<div class="font-size-10 cl-secondary font-weight-500">{{ detailHistoryTransfer.bonus_transfer_network_code }}</div>
						</div>
						<div class="pt-2">
							<div class="font-size-10">Nama Mitra</div>
							<div class="font-size-10 cl-secondary font-weight-500">{{ detailHistoryTransfer.bonus_transfer_member_name }}</div>
						</div>
					</v-col>
					<v-col cols="6" md="3" class="text-right">
						<div>
							<div class="font-size-10">Nama Bank</div>
							<div class="font-size-10 cl-secondary font-weight-500">{{ detailHistoryTransfer.bonus_transfer_bank_name ? detailHistoryTransfer.bonus_transfer_bank_name : '-' }}</div>
						</div>
						<div class="pt-2">
							<div class="font-size-10">Nomor Rekening</div>
							<div class="font-size-10 cl-secondary font-weight-500">{{ detailHistoryTransfer.bonus_transfer_bank_account_no ? detailHistoryTransfer.bonus_transfer_bank_account_no : '-' }}</div>
						</div>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="6" md="9" class="pb-1">
						<div class="font-size-10 font-weight-500">Jenis Komisi</div>
					</v-col>
					<v-col cols="6" md="3" class="pb-1 text-right">
						<div class="font-size-10 font-weight-500">Jumlah (Rp)</div>
					</v-col>
					<v-col cols="6" md="6" class="pb-0 pr-0">
						<div class="font-size-10">Sponsor</div>
						<div class="pt-3 border-bottom border-grey border-2px"></div>
					</v-col>
					<v-col cols="6" md="6" class="pb-0 pl-0 text-right">
						<div class="font-size-10">{{ detailHistoryTransfer.bonus_transfer_bonus_sponsor | toNumber }}</div>
						<div class="pt-3 border-bottom border-grey border-2px"></div>
					</v-col>
					<v-col cols="6" md="6" class="pb-0 pr-0">
						<div class="font-size-10">Team</div>
						<div class="pt-3 border-bottom border-grey border-2px"></div>
					</v-col>
					<v-col cols="6" md="6" class="pb-0 pl-0 text-right">
						<div class="font-size-10">{{ detailHistoryTransfer.bonus_transfer_bonus_team | toNumber }}</div>
						<div class="pt-3 border-bottom border-grey border-2px"></div>
					</v-col>
					<v-col cols="6" md="6" class="pb-0 pr-0">
						<div class="font-size-10">Cashback</div>
						<div class="pt-3 border-bottom border-grey border-2px"></div>
					</v-col>
					<v-col cols="6" md="6" class="pb-0 pl-0 text-right">
						<div class="font-size-10">{{ detailHistoryTransfer.bonus_transfer_bonus_cashback | toNumber }}</div>
						<div class="pt-3 border-bottom border-grey border-2px"></div>
					</v-col>
					<v-col cols="6" md="6" class="pb-0 pr-0">
						<div class="font-size-10">Reward</div>
						<div class="pt-3 border-bottom border-grey border-2px"></div>
					</v-col>
					<v-col cols="6" md="6" class="pb-0 pl-0 text-right">
						<div class="font-size-10">{{ detailHistoryTransfer.bonus_transfer_bonus_reward | toNumber }}</div>
						<div class="pt-3 border-bottom border-grey border-2px"></div>
					</v-col>
				</v-row>
				<v-row>
					<v-col md="6" class="d-none d-sm-block"></v-col>
					<v-col md="6">
						<v-row>
							<v-col cols="6" md="6" class="pb-0 pr-0">
								<div class="font-size-11 font-weight-500">Total Komisi</div>
								<div class="pt-3 border-bottom border-grey border-2px"></div>
							</v-col>
							<v-col cols="6" md="6" class="pb-0 pl-0 text-right">
								<div class="font-size-11 font-weight-500">{{ detailHistoryTransfer.bonus_transfer_total_bonus | toNumber }}</div>
								<div class="pt-3 border-bottom border-grey border-2px"></div>
							</v-col>
							<v-col cols="6" md="6" class="pb-0 pr-0" v-if="false">
								<div class="font-size-11 red--text">Potongan</div>
								<div class="pt-3 border-bottom border-grey border-2px"></div>
							</v-col>
							<v-col cols="6" md="6" class="pb-0 pl-0 text-right" v-if="false">
								<div class="font-size-11 red--text">{{ detailHistoryTransfer.bonus_transfer_adm_charge_value | toNumber }}</div>
								<div class="pt-3 border-bottom border-grey border-2px"></div>
							</v-col>
							<v-col cols="6" md="6" class="pb-0 pr-0" v-if="false">
								<div class="font-size-12 font-weight-500">Total</div>
							</v-col>
							<v-col cols="6" md="6" class="pb-0 pl-0 text-right" v-if="false">
								<div class="font-size-12 font-weight-500">{{ detailHistoryTransfer.bonus_transfer_nett | toNumber }}</div>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</div>

			<div class="mt-4" v-if="loading">
				<v-row>
					<v-col cols="12" sm="12" md="12">
						<LoadData :loading="loading"></LoadData>
					</v-col>
				</v-row>
			</div>
		</v-col>
	</v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
	components: {
	},
	data() {
		return {
			loading: false,
			transferStatus: [
				{
					status: 'success',
					color: 'success--text',
					label: 'Sukses',
					icon: 'mdi-check-decagram-outline'
				},
				{
					status: 'pending',
					color: 'warning--text',
					label: 'Pending',
					icon: 'mdi-timer-sand'
				},
				{
					status: 'failed',
					color: 'error--text',
					label: 'Gagal',
					icon: 'mdi-close-circle-outline'
				}
			]
		}
	},
	computed: {
		...mapState('bonus', ['detailHistoryTransfer']),
	},
	methods: {
		...mapActions('bonus', ['getDetailHistoryTransfer']),

		getTransferStatus(status) {
			const transfer = this.transferStatus.find(x => x.status === status)
			if (transfer) return transfer
			else {
				const nontransfer = {
					status: '',
					color: 'secondary',
					label: '',
					icon: ''
				}
				return nontransfer
			}
		},

		goPrint() {
			window.print()
		}
	},
	async created() {
		const authData = await localStorage.getItem('mlmcore-vo-auth-data');
		const data = await JSON.parse(authData)

		await this.$store.dispatch('setPageTitle', `Bonus Statement`)
		this.loading = await true
		await this.getDetailHistoryTransfer({ transfer_id: this.$route.params.slug })
		if (data.member_network_code !== this.detailHistoryTransfer.bonus_transfer_network_code) this.$router.push({name: 'history-transfer'})

		setTimeout(() => {
			this.loading = false
		}, 500);
	}
};
</script>